module.exports = __webpack_public_path__ + "img/anli-1.91f7c5e5.jpg";